"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.canMakeTransition = exports.isUserAllowed = exports.canTransitionQuoteState = exports.transitions = void 0;
var cart_service_1 = require("../../services/cart-service");
var auth_service_1 = require("../../services/auth-service");
var state_machine_1 = require("../../libs/state-machine");
exports.transitions = {
    adjust: [cart_service_1.QuoteStatus.AVAILABLE],
    adjusted: [cart_service_1.QuoteStatus.ADJUSTING],
    approve: [cart_service_1.QuoteStatus.AVAILABLE],
    fulfill: [cart_service_1.QuoteStatus.PROCESSING],
    place: [cart_service_1.QuoteStatus.APPROVED],
    process: [cart_service_1.QuoteStatus.PENDING, cart_service_1.QuoteStatus.REJECTED],
    recover: [cart_service_1.QuoteStatus.ERRORED],
    reject: [cart_service_1.QuoteStatus.AVAILABLE],
    revert: [cart_service_1.QuoteStatus.AVAILABLE],
};
var guards = {
    'can-modify': {
        on: cart_service_1.QuoteTransitionName.ADJUST,
        allowedUserTypes: [auth_service_1.UserType.CUSTOMER],
    },
    'can-request-with-user-type': {
        on: cart_service_1.QuoteTransitionName.ADJUSTED,
        allowedUserTypes: [auth_service_1.UserType.CUSTOMER],
    },
    'can-approve': {
        on: cart_service_1.QuoteTransitionName.APPROVE,
        allowedUserTypes: [auth_service_1.UserType.CUSTOMER],
    },
    'can-fulfill-with-user-type': {
        on: cart_service_1.QuoteTransitionName.FULFILL,
        allowedUserTypes: [auth_service_1.UserType.ADMIN, auth_service_1.UserType.SUPER_ADMIN],
    },
    'can-place': {
        on: cart_service_1.QuoteTransitionName.PLACE,
        allowedUserTypes: [auth_service_1.UserType.CUSTOMER, auth_service_1.UserType.ADMIN, auth_service_1.UserType.SUPER_ADMIN],
    },
    'can-manage': {
        on: cart_service_1.QuoteTransitionName.PROCESS,
        allowedUserTypes: [auth_service_1.UserType.ADMIN, auth_service_1.UserType.SUPER_ADMIN],
    },
    'can-recover': {
        on: cart_service_1.QuoteTransitionName.RECOVER,
        allowedUserTypes: [auth_service_1.UserType.ADMIN, auth_service_1.UserType.SUPER_ADMIN],
    },
    'can-reject': {
        on: cart_service_1.QuoteTransitionName.REJECT,
        allowedUserTypes: [auth_service_1.UserType.CUSTOMER],
    },
    'can-revert': {
        on: cart_service_1.QuoteTransitionName.REVERT,
        allowedUserTypes: [auth_service_1.UserType.ADMIN, auth_service_1.UserType.SUPER_ADMIN],
    },
};
var canTransitionQuoteState = function (quote, transition) {
    return (0, state_machine_1.canTransitState)(quote.status, exports.transitions[transition]);
};
exports.canTransitionQuoteState = canTransitionQuoteState;
var isUserAllowed = function (transition, userType) {
    return Object.values(guards).some(function (guard) {
        return guard.on === transition && guard.allowedUserTypes.includes(userType);
    });
};
exports.isUserAllowed = isUserAllowed;
var canMakeTransition = function (quote, transition, userType) {
    return (0, exports.canTransitionQuoteState)(quote, transition) && (0, exports.isUserAllowed)(transition, userType);
};
exports.canMakeTransition = canMakeTransition;
//# sourceMappingURL=quote-helpers.js.map